export const INTERVIEW_PARTICIPANT_MODEL = "interview-participant";
import { USER_MODEL } from "@/models/user-model";
import pluralize from "pluralize";

const interviewParticipantModel = {
  participantRsvpStatus: null,
  participantType: "",
  participantAvailability: false,
  user: {
    jsonApi: "hasOne",
    type: pluralize(USER_MODEL)
  },
  reason: "",
  adjustmentRequested: "",
  adjustmentForConfirmed: false,
  comments: {
    jsonApi: "hasMany",
    type: "comment"
  }
};

export default interviewParticipantModel;
